import scrollIt from './scroll-it';

const SCROLL_DURATION = 450;

const initAnchors = () => {
  const anchorElements = [...document.querySelectorAll('.anchor')];

  for (const anchor of anchorElements) {
    const targetSection = document.querySelector(anchor.hash);
    if (!targetSection) return;

    const onAnchorClick = (evt) => {
      evt.preventDefault();

      scrollIt(
        targetSection,
        SCROLL_DURATION,
        'easeInOutCubic'
      );
    };
    anchor.addEventListener('click', onAnchorClick);
  }
};

export default initAnchors;
